import React from 'react';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative h-[60vh] min-h-[500px] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <Image
          src="/assets/images/A038A259-FC75-4E82-B1CE-DBFAF08EF619-1765250829061.png"
          alt="Stunning landscape photo of Puerto Princesa Subterranean River featuring crystal clear turquoise water, dramatic limestone karst formations with caves, tourist boat with visitors, lush green vegetation hanging from cliff faces, perfect representation of the mountain-to-sea theme and underground river experience"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-[var(--color-primary)]/80 via-[var(--color-primary)]/60 to-background"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-[var(--color-accent)]/20 rounded-full mb-6">
            <span className="text-[var(--color-accent)] dark:text-[var(--color-tertiary)] font-medium text-sm">Community-Powered Conservation</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Together We Protect Paradise
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Join our vibrant community of local guardians, volunteers, and conservation champions preserving the Puerto Princesa Subterranean River National Park for future generations.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="bg-card/80 backdrop-blur-sm px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-[var(--color-accent)] dark:text-[var(--color-tertiary)]">2,847</div>
              <div className="text-sm text-gray-200 dark:text-gray-300">Active Volunteers</div>
            </div>
            <div className="bg-card/80 backdrop-blur-sm px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-[var(--color-success)] dark:text-[var(--color-tertiary)]">156</div>
              <div className="text-sm text-gray-200 dark:text-gray-300">Community Projects</div>
            </div>
            <div className="bg-card/80 backdrop-blur-sm px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-[var(--color-info)] dark:text-[var(--color-tertiary)]">₱8.4M</div>
              <div className="text-sm text-gray-200 dark:text-gray-300">Economic Impact</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;